import { useAppRouter } from './useAppRouter';
import { getBrowserPathFromAsPath } from '../../utils/getBrowserPathFromAsPath';

/**
 * Returns the resolved URL pathname (without query or hash), relative to the app
 * basename (e.g. `/v2`). Derived from `useAppRouter().asPath`, not
 * `useAppRouter().pathname` — on Pages Router the latter is the route pattern
 * (e.g. `/account/apps/[...slug]`), while this hook returns the browser path
 * (e.g. `/account/apps/library`).
 *
 * Today `useAppRouter` is Next.js Pages Router–backed; this hook mirrors
 * `next/navigation`'s `usePathname` so call sites can avoid App Router–only
 * imports. When routing moves to React Router 7, keep using this hook: an RR7
 * `useAppRouter` implementation should preserve the same `asPath` contract and
 * this function can stay unchanged.
 */
export const usePathname = (): string => {
  const { asPath } = useAppRouter();

  return getBrowserPathFromAsPath(asPath);
};
